import { Typography } from '../../../components/atoms';
import { PDFFooter } from '../PDFFooter/PDFFooter';
import { PDFHeader } from '../PDFHeader/PDFHeader';
import { useTranslation } from 'react-i18next';
import { Grid, styled } from '@mui/material';

export interface PDFImportantInformationProps {
    advisorName: string;
    advisorEmail: string;
    totalPages: number;
}

const Address = styled('span')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    borderTop: `1px solid ${theme.palette.grey[200]}`
}));

const ADInfo = styled('div')(() => ({
    margin: '20px 0 8px'
}));

const Caveat = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    border: `1px solid ${theme.palette.semantic.text.default}`,
    // marginBottom: '50px',
    width: 'fit-content'
}));
const Column = styled('div')(({ theme }) => ({
    borderRight: `1px solid ${theme.palette.semantic.text.default}`,
    padding: '4px 16px'
}));

export const PDFImportantInformation = ({ advisorEmail, advisorName, totalPages }: PDFImportantInformationProps) => {
    const { t } = useTranslation();

    return (
        <Grid height={'980px'} position={'relative'}>
            <PDFHeader pageName={t('IMPORTANT_INFO')} />
            <Address>
                <ADInfo>
                    <Typography
                        variant="headers.h5Bold"
                        label={t('ADVISOR_INFO')}
                        sx={{ lineHeight: '24px', marginTop: '15px' }}
                    />
                </ADInfo>
                <Typography
                    variant="headers.h5Bold"
                    label={advisorName}
                    sx={{ lineHeight: '24px', fontSize: '20px' }}
                />
                <Typography
                    variant="headers.h5"
                    label={t('TEXT_ADMIN_CLIENTS_TABLE_HEADER_3')}
                    sx={{ lineHeight: '24px' }}
                />
                <Typography variant="body.largeBold" label={advisorEmail} sx={{ fontWeight: '600' }} />

                <ADInfo>
                    <Typography variant="headers.h5Bold" label={t('IMPORTANT_INFO')} />
                </ADInfo>
            </Address>

            <Typography t={'IMPORTANT_INFO_CONTENT'} variant="body.large" />

            <Caveat>
                <Column>
                    <Typography variant="body.largeBold" label={t('NOT_FDIC')} />
                </Column>
                <Column>
                    <Typography variant="body.largeBold" label={t('LOSE_MONEY')} />
                </Column>
                <Column>
                    <Typography variant="body.largeBold" label={t('NO_BANK')} />
                </Column>
            </Caveat>

            <Typography variant="headers.h5Bold">
                {t('PDF_IMPORTANT_INFO_COPY_TEXT', { year: new Date().getFullYear().toString() })}
            </Typography>

            <PDFFooter currentPage={totalPages} totalPages={totalPages} useSingleLineFooter />
        </Grid>
    );
};
